module.exports = __webpack_public_path__ + "static/media/logo.ca3548de.svg";